import { makeStyles } from "@fluentui/react-components";
import { customTokens } from "../../theme/theme";

export const useContainerStyles = makeStyles({
  container: {
    backgroundColor: customTokens.colorNeutralPrimaryGrey4,
    padding: "48px 240px",
    display: "flex",
    flexDirection: "column",
    gap: "32px",

    "@media (max-width: 1440px)": {
      padding: "48px 120px",
    },

    "@media (min-width: 769px) and (max-width: 1024px)": {
      padding: "48px 64px",
      gap: "16px",
    },

    "@media (max-width: 768px)": {
      gap: "16px",
      padding: "32px 20px",
    },
  },
});
